import api from './api';

const addonService = {
  getAddons: async () => {
    const response = await api.get('/api/addons');
    return response.data;
  },

  createAddon: async (addonData) => {
    const response = await api.post('/api/addons', addonData);
    return response.data;
  },

  updateAddon: async (id, updateData) => {
    const response = await api.put(`/api/addons/${id}`, updateData);
    return response.data;
  },

  deleteAddon: async (id) => {
    const response = await api.delete(`/api/addons/${id}`);
    return response.data;
  },
};

export default addonService;
